<template>
	<v-container grid-list-xl>
		<v-layout
			v-if="$userCan('project_access') && !report.isArchivedOrParentArchived"
			row
			wrap
			ma-0
			justify-center
			align-center
			class="text-xs-center"
		>
			<v-flex
				xs12
				md8
				ma-0
				pa-0
			>
				<slot name="alert" />
			</v-flex>
			<v-flex xs12 xl8 pa-0 mb-3>
				<transition
					name="scale-transition"
					mode="out-in"
				>
					<v-btn
						v-if="!showAddArticle"
						color="primary"
						ripple
						@click="showAddArticle = true"
					>
						Add Articles
					</v-btn>
					<v-card v-else class="text-xs-left">
						<AddArticle
							closable
							@single-edit="setEditArticle"
							@close="showAddArticle = false"
						/>
					</v-card>
				</transition>
			</v-flex>
		</v-layout>
		<ArticleIterator
			:items="articles"
			:selected="selected"
			@selected="selected = $event"
			@set-image="setImageUpload"
			@set-add-reprints="setAddReprints"
			@set-report-image="setReportImage"
			@set-project-image="setProjectImage"
			@edit="setEditArticle"
		/>
		<FullDialog
			:dialog="editArticle.show"
			dialog-title="Edit Article"
			@close-dialog="editArticle.show = false"
		>
			<template
				v-if="editArticle.show"
				slot="dialog-content"
			>
				<EditArticle
					:article="editArticle.article"
					single-edit
					@saving-done="editArticle.show = false"
					@close="editArticle.show = false"
					@set-image="setImageUpload"
				/>
			</template>
		</FullDialog>
		<v-dialog
			ref="dialog"
			v-model="imageUpload.show"
			max-width="800px"
		>
			<v-card v-if="imageUpload.show" class="px-3">
				<ImageUpload
					:item="imageUpload.article"
					closable
					@close="imageUpload.show = false"
				>
					<template slot="title">Upload Article Image</template>
				</ImageUpload>
			</v-card>
		</v-dialog>
		<v-dialog
			ref="dialog"
			v-model="addReprints.show"
			max-width="800px"
		>
			<v-card v-if="addReprints.show" class="px-3">
				<AddReprints
					:item="addReprints.article"
					closable
					@close="addReprints.show = false"
				>
<!--					<template slot="title">Upload Article Image</template>-->
				</AddReprints>
			</v-card>
		</v-dialog>
	</v-container>
</template>

<script>
import { sync } from 'vuex-pathify';
import ArticlesListMixins from '@/mixins/ArticlesListMixins';
import ArticleIterator from '@/components/Article/ArticleIterator';
import AddArticle from '@/components/Article/AddArticle';
import EditArticle from '@/components/Article/EditArticle';
import FullDialog from '@/components/FullDialog';
import ImageUpload from '@/components/ImageUpload';
import AddReprints from '@/components/Article/AddReprints';

export default {
	components: {
		AddReprints,
		AddArticle,
		EditArticle,
		FullDialog,
		ArticleIterator,
		ImageUpload,
	},
	mixins: [ArticlesListMixins],
	props: {
		singleEdit: { type: Object, default: null },
	},
	computed: {
		report: sync('reports/currentReport'),
		showAddArticle: sync('articlesNew/showAddArticlesForm'),
	},
	watch: {
		singleEdit(val) {
			if (!val) {
				return;
			}
			this.setEditArticle(val);
		},
		'$route.name'(val) {
			// Close the add article form when going away from this route
			if (val !== 'ArticlesList') {
				this.showAddArticle = false;
			}
		},
	},
	beforeRouteUpdate(to, from, next) {
		// For updating inside same route
		this.$store.dispatch('reports/loadCurrentReportAndRelatedData', to.params.reportId).then().catch((e) => {
			this.$notify('error', 'Failed to retrieve Report.');
			this.$router.push({ name: 'Error' });
		});
		
		next();
	},
	beforeRouteLeave(to, from, next) {
		this.showAddArticle = false;
		next();
	},
};
</script>

<style lang="scss" scoped>
.absolute--right {
	position: absolute;
	top: 0;
	right: 0;
}
.fill--height {
	height: 100%;
}
.v-input--checkbox {
	margin: 0;
}
</style>
